import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { SplashScreenService } from '@fitup-monorepo/core/lib/services/splash-screen/splash-screen.service';
import { AuthServerProvider } from '@fitup-monorepo/core/lib/services/auth/auth-jwt.service';
import { AppRoutes } from '@fitup-monorepo/routes/lib/app-routes';

export const welcomePageGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const authServerProvider = inject(AuthServerProvider);
  const router = inject(Router);
  const splashScreenService = inject(SplashScreenService);
  const isLoggedIn = await authServerProvider.isAuthenticated();

  if (!isLoggedIn) {
    await splashScreenService.hide();

    return true;
  }
  return router.parseUrl(AppRoutes.TABS_HOME);
};
